<template>
  <div class="col-md-12 mail_list">

    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <fg-input
              v-model="filter.q"
              class="filter"
              :placeholder="translate('search')"
              :clearable="true"
              @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
              :options="category_list"
              :multiple="false"
              v-model="filter.category"
              :placeholder="translate('support.mail_list.category')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="action_list"
              :multiple="false"
              v-model="filter.action"
              :placeholder="translate('support.mail_list.action')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select"></div>
        <div class="form_select"></div>
      </div>
    </div>

    <div class="response_table" >
      <div class="loading" v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" class="w50">{{ translate('support.mail_list.id') }}</th>
            <th scope="col">{{ translate('support.mail_list.mailbox') }}</th>
            <th scope="col">{{ translate('support.mail_list.message_id') }}</th>
            <th scope="col">{{ translate('support.mail_list.from_email') }}</th>
            <th scope="col" class="w10per">{{ translate('support.mail_list.subject') }}</th>
            <th scope="col">{{ translate('support.mail_list.received_at') }}</th>
            <th scope="col">{{ translate('support.mail_list.device_id') }}</th>
            <th scope="col">{{ translate('support.mail_list.ticket_id') }}</th>
            <th scope="col">{{ translate('support.mail_list.status_title') }}</th>
            <th scope="col">{{ translate('support.mail_list.processed_at') }}</th>
            <th scope="col">{{ translate('support.mail_list.category') }} </th>
            <th scope="col">{{ translate('support.mail_list.action') }} </th>
            <th scope="col">{{ translate('support.mail_list.action_reason') }}</th>
            <th scope="col">{{ translate('support.mail_list.target_folder') }}</th>
          </tr>
        </thead>
        <tbody>
          <MailListItem
              v-for="(mail,key) in mail_list"
              :key="key"
              :mail="mail"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import MailListItem from "./MailListItem/MailListItem.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'MailList',
  components: {
    WrapDatePicker,
    MailListItem
  },
  props: {
    active: Boolean,
    groups_servers: Array
  },
  data () {
    return {
      mails: [],
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter:{
        q: "",
        category: null,
        action: null
      },

    }
  },

  computed:{
    sended_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        if (this.filter[item] !== null && this.filter[item] !== undefined && this.filter[item] !== ""){
          filter[item] = this.filter[item]
        }
      })
      return filter
    },
    category_list(){
      return [
        {id: "new_ticket", label: "new_ticket"},
        {id: "reply_with_ticket", label: "reply_with_ticket"},
        {id: "system_notification", label: "system_notification"},
        {id: "auto_reply", label: "auto_reply"},
        {id: "delivery_report", label: "delivery_report"},
        {id: "manual_review", label: "manual_review"},
        {id: "ignored", label: "ignored"},
        {id: "apn_t2_reply", label: "apn_t2_reply"}
      ]
    },
    action_list(){
      return [
        {id: "create_ticket", label: "create_ticket"},
        {id: "link_ticket", label: "link_ticket"},
        {id: "mark_seen", label: "mark_seen"},
        {id: "move_to_folder", label: "move_to_folder"},
        {id: "mark_seen_and_move", label: "mark_seen_and_move"},
        {id: "skip", label: "skip"},
        {id: "manual_review", label: "manual_review"},
        {id: "process_apn_t2", label: "process_apn_t2"},
      ]
    },
    mail_list(){
      return JSON.parse(JSON.stringify(this.mails))
    }
  },

  created() {
    this.get_inbox_emails()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_inbox_emails, 200)
    },
    get_inbox_emails(){
      this.loading = true
      this.$http.v1.getSupportInboxEmails(this.sended_filter, (response) => {
        this.mails = response.data
        this.loading = false
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>
  .mail_list{
    height: 100%;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      flex: 1;
      margin-bottom: 10px;
      & > *{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
      .filter{
        margin: 0;
      }
      .form{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 2;

        .search_user{
          margin-bottom: 0;
          width: 100%;
        }
        .btn{
          width: 30%;
        }
      }
      .form_select{
        flex: 1;
        .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }

    .loading {
      background-color: #fff;
      height: calc(100% - 80px);
      width: calc(100% - 30px);
    }

    .response_table{
      flex: 10;
      padding: 0;
    }
  }

</style>
